import { captureMessage } from '@sentry/react';

export interface CdmChecklistServiceUtilsContextInterface {
  captureMessage: typeof captureMessage;
}

export const cdmChecklistServiceUtilsContext: CdmChecklistServiceUtilsContextInterface =
  {
    captureMessage,
  };
